import { render } from "./EditButton.vue?vue&type=template&id=5f437f2e&ts=true"
import script from "./EditButton.vue?vue&type=script&lang=ts"
export * from "./EditButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__